import { IStore } from "../Models/Models";

export const timeoutPromise = (ms: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
};

export const isMobileDevice = (): boolean => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
};

export const StoreAddressData = (store: IStore): string => {
    let fullAddress = "";

    if (store.storeNumber && store.storeNumber.trim() !== "") {
        fullAddress += store.storeNumber;
    }

    if (store.storeName && store.storeName.trim() !== "") {
        fullAddress += " - ";
        fullAddress += store.storeName;
    }

    if (store.address.address1 && store.address.address1.trim() !== "") {
        fullAddress += " - ";
        fullAddress += store.address.address1;
    }

    if (store.address.city && store.address.city.trim() !== "") {
        fullAddress += " ";
        fullAddress += store.address.city;
    }

    if (store.address.state && store.address.state.trim() !== "") {
        fullAddress += " ";
        fullAddress += store.address.state;
    }

    if (store.address.zip && store.address.zip.trim() !== "") {
        fullAddress += " ";
        fullAddress += store.address.zip;
    }

    return fullAddress;
};

export const between = (value: number, min: number, max: number, inclusive = true): boolean => {
    if (inclusive) {
        return value >= min && value <= max;
    }

    return value > min && value < max;
};
